    import { DayOfWeekEnum } from 'app/models';

export class BoundaryFeeModel {
    Id!: number;
    BoundaryAmount!: number;
    BoundaryProcessingFee: number = 10;
    BoundaryAvailableDays: DayOfWeekEnum[] = [];
    BoundaryAvailableFromHours!: number;
    BoundaryAvailableFromMins!: number;
    BoundaryAvailableToHours!: number;
    BoundaryAvailableToMins!: number;

    constructor(payload?: { [key: string]: any }) {
        Object.assign(this, payload);
    }

    public IsBoundaryFieldsFilled(): boolean {
        if (this.BoundaryAmount && this.BoundaryProcessingFee && this.BoundaryAvailableDays.length !== 0) {
            return true;
        }
        return false;
    }

    public GetBoundaryEarning(): string {
        let earning = 0;
        if (this.BoundaryAmount && this.BoundaryAmount > this.BoundaryProcessingFee) {
            earning = this.BoundaryAmount - this.BoundaryProcessingFee;
        }
        return earning.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
}
